"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  RadioGroup: true
};
exports.default = exports.RadioGroup = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _ValidationTooltip = require("../Tooltip/_ValidationTooltip");
var _FormField = require("../FormField/_FormField");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _RadioGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./RadioGroup.css") : void 0);
var _RadioGroup2 = require("./RadioGroup.types");
Object.keys(_RadioGroup2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _RadioGroup2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RadioGroup2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-radio-group';
/**
 * **RadioGroup** groups a collection of radio buttons into a single input value.
 *
 * **Radio** is a specialized form control that emits an `<input>` with a type of radio.
 *
 * **RadioGroup** provides users with a set of mutually exclusive options.
 * It allows a user to select only one option from two or more choices.
 * Each option is represented by a radio button.
 * Consequently, radio buttons only work in groups.
 * */
const RadioGroup = exports.RadioGroup = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildPropsFromContextAbove = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildPropsFromContextAbove ? Object.assign(Object.assign({}, _props), addChildPropsFromContextAbove(RadioGroup, _props)) : _props;
  const {
      children,
      className,
      childRadioLabelClass,
      decorators,
      disabled,
      headingProps,
      tailContainerProps,
      inline,
      label,
      labelProps,
      layout = 'vertical',
      inputDescribedby,
      name,
      onChange = () => {},
      controlProps,
      controlContainerProps,
      readOnly,
      required,
      validationMessage,
      validationOverlayProps
    } = props,
    otherProps = __rest(props, ["children", "className", "childRadioLabelClass", "decorators", "disabled", "headingProps", "tailContainerProps", "inline", "label", "labelProps", "layout", "inputDescribedby", "name", "onChange", "controlProps", "controlContainerProps", "readOnly", "required", "validationMessage", "validationOverlayProps"]);
  const classnames = _bind.default.bind(_RadioGroup.default);
  let groupId = (0, _useUniqueId.default)();
  if (controlProps === null || controlProps === void 0 ? void 0 : controlProps.id) groupId = controlProps.id;
  let labelId = (0, _useUniqueId.default)();
  if (labelProps === null || labelProps === void 0 ? void 0 : labelProps.id) labelId = labelProps.id;
  const validationId = (0, _useUniqueId.default)();
  const addChildProps = (child, childProps, attributes) => {
    if (child.displayName === 'Radio') {
      return Object.assign(Object.assign({}, attributes), {
        disabled: typeof (childProps === null || childProps === void 0 ? void 0 : childProps.disabled) !== 'undefined' ? childProps.disabled : disabled,
        readOnly: typeof (childProps === null || childProps === void 0 ? void 0 : childProps.readOnly) !== 'undefined' ? childProps.readOnly : readOnly,
        name: (childProps === null || childProps === void 0 ? void 0 : childProps.name) || name || groupId,
        required,
        onChange: (childProps === null || childProps === void 0 ? void 0 : childProps.onChange) || onChange,
        state: validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state,
        labelClassName: classnames(childProps === null || childProps === void 0 ? void 0 : childProps.labelClassName, childRadioLabelClass)
      });
    }
    return {};
  };
  const getHeadingStartDecorators = () => {
    const decoratorArray = [];
    if (!disabled && !readOnly && (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text) && (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state)) {
      decoratorArray.push(/*#__PURE__*/_react.default.createElement(_ValidationTooltip.ValidationTooltip, {
        state: validationMessage.state,
        text: validationMessage.text
      }));
    }
    return [..._react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.headingStart), ...decoratorArray];
  };
  const renderRadioInputs = parameters => (/*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: (child, childProps) => addChildProps(child, childProps, {
      'aria-describedby': parameters['aria-describedby']
    })
  }, children));
  const getInputDescribedBy = () => {
    const describedByArr = [];
    if (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text) {
      describedByArr.push(validationId);
    }
    if (inputDescribedby) {
      describedByArr.push(inputDescribedby);
    }
    return describedByArr.length > 0 ? describedByArr.join(' ') : undefined;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FormField.FormField, Object.assign({}, otherProps, {
    className: classnames(CSS_BLOCK, className, {
      [`${CSS_BLOCK}--${layout}`]: layout !== 'vertical'
    }),
    disabled: disabled,
    decorators: Object.assign(Object.assign({}, decorators), {
      headingStart: getHeadingStartDecorators()
    }),
    headingProps: Object.assign(Object.assign({}, headingProps), {
      className: classnames(`${CSS_BLOCK}__heading`, headingProps === null || headingProps === void 0 ? void 0 : headingProps.className)
    }),
    tailContainerProps: Object.assign(Object.assign({}, tailContainerProps), {
      className: classnames(`${CSS_BLOCK}__tail-container`, tailContainerProps === null || tailContainerProps === void 0 ? void 0 : tailContainerProps.className)
    }),
    label: label,
    labelProps: Object.assign(Object.assign({}, labelProps), {
      id: labelId,
      className: classnames(`${CSS_BLOCK}__label`, labelProps === null || labelProps === void 0 ? void 0 : labelProps.className)
    }),
    layout: layout,
    inputId: groupId,
    inputDescribedby: getInputDescribedBy(),
    readOnly: readOnly,
    ref: ref,
    controlContainerProps: Object.assign(Object.assign({}, controlContainerProps), {
      className: classnames(`${CSS_BLOCK}__control-container`, controlContainerProps === null || controlContainerProps === void 0 ? void 0 : controlContainerProps.className)
    }),
    controlProps: Object.assign(Object.assign({
      role: 'radiogroup'
    }, controlProps), {
      'aria-labelledby': labelId,
      overrideControlClasses: true,
      className: classnames(`${CSS_BLOCK}__container`, controlProps === null || controlProps === void 0 ? void 0 : controlProps.className, {
        [`${CSS_BLOCK}__container--inline`]: inline,
        [`${CSS_BLOCK}__container--disabled`]: disabled
      }),
      id: groupId
    }),
    renderInput: renderRadioInputs,
    required: required,
    validationOverlayProps: Object.assign(Object.assign({}, validationOverlayProps), {
      targetClassName: classnames(`${CSS_BLOCK}__overlay`, validationOverlayProps === null || validationOverlayProps === void 0 ? void 0 : validationOverlayProps.targetClassName)
    })
  })), (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text) && (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}--screen-reader-only`),
    id: validationId
  }, validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text)));
});
RadioGroup.displayName = 'RadioGroup';
var _default = exports.default = RadioGroup;